module.exports = __webpack_public_path__ + "static/media/lastpass-solutions-logo.df34ca13.png";